<template>
  <div class="mnt-body">
    <div class="mnt-when">
      <span class="mnt-when-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13v5l3 2" /></svg></span>
      <div class="mnt-when-item">
        <span class="mnt-when-label">停机时间</span>
        <b>{{ payload.maintenanceStartText }}</b>
      </div>
      <span class="mnt-when-arrow"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg></span>
      <div class="mnt-when-item">
        <span class="mnt-when-label">预计恢复</span>
        <b>{{ payload.maintenanceEndText }}</b>
      </div>
    </div>
    <ul class="mnt-points">
      <li v-for="(item, index) in payload.items" :key="index">{{ item }}</li>
    </ul>
  </div>
</template>

<script setup>
defineProps({
  payload: { type: Object, required: true },
})
</script>

<style scoped>
.mnt-body { width: 100%; }
.mnt-when { display: flex; align-items: center; flex-wrap: wrap; gap: 10px 20px; background: #f8faff; border-radius: 13px; padding: 16px 20px; }
.mnt-when-icon { display: grid; place-items: center; flex: 0 0 35px; width: 35px; height: 35px; background: #e7edff; color: #0840e6; border-radius: 10px; }
.mnt-when-icon svg { width: 21px; height: 21px; fill: none; stroke: currentColor; stroke-width: 1.7; stroke-linecap: round; stroke-linejoin: round; }
.mnt-when-item { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.mnt-when-label { font-size: 12px; color: #69778f; }
.mnt-when-item b { font-size: 17px; font-weight: 650; color: #17233d; font-variant-numeric: tabular-nums; letter-spacing: -.2px; line-height: 1.3; }
.mnt-when-arrow { color: #9aa7c7; display: flex; }
.mnt-when-arrow svg { width: 20px; height: 20px; fill: none; stroke: currentColor; stroke-width: 1.7; stroke-linecap: round; stroke-linejoin: round; }
.mnt-points { margin: 18px 0 0; padding-left: 20px; display: flex; flex-direction: column; gap: 8px; list-style: disc; }
.mnt-points li { font-size: 13px; line-height: 1.8; color: #69778f; }
.mnt-points li::marker { color: #9aa7c7; }
</style>
